import { InspectorPanelAccordionExport } from "../accordion/export/InspectorPanelAccordionExport"
import { InspectorPanelMetadata } from "../FlightPanelMetadata"
import { SidePanelLayer } from "@nova/constants"
import { useDownloadButtonData } from "plugins/Panorama/usePanoramaDownloadButtonData"
import { useAppSelector } from "integrations/redux/hooks"
import { selectVideoFlightById } from "features/entity-caching/flights/selectors"

export const InspectorPanelPanoramaData = ({ id }: { id: string }) => {
    const flight = useAppSelector(selectVideoFlightById(id))
    const downloadOptions = useDownloadButtonData()

    return (
        <div className="mb-2 flex flex-col gap-2">
            {/* Export */}
            <InspectorPanelAccordionExport
                exportOptions={downloadOptions.exportOptions}
                canOnlyPickOne={true}
            />

            <InspectorPanelMetadata
                entity={flight as SidePanelLayer}
                uploads={[]}
                completedUploadCount={1}
            />
        </div>
    )
}
